import { configureStore } from '@wolffun/app-manager';
import { reducers } from './reducers';
import { injectProfileReducers } from '@profile/src/redux/injectProfileReducers';
const store = configureStore(reducers); // force inject profile reducers immediately because profile is a core plugin

injectProfileReducers(store);
export default store;